import { jsxs, jsx } from 'react/jsx-runtime';
import { themedColor, font, Flex } from '@lemonade-hq/cdk';
import styled from 'styled-components';

function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  width: 1px;\n  height: 16px;\n  background-color: ",
        ";\n  @media (max-width: 355px) {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  text-decoration: none;\n  cursor: pointer;\n  white-space: nowrap;\n\n  &:hover span {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Divider = styled.div(_templateObject(), themedColor("metal"));
var StepLink = styled.a(_templateObject1(), font("main", {
    fontSize: "16px",
    fontWeight: 400
}), themedColor("metal"));
var defaultContactDetails = {
    email: "help@lemonade.com",
    phone: "1-844-733-8666",
    showDivider: true
};
var ContactDetails = function(param) {
    var contactDetails = param.contactDetails;
    var contact = contactDetails !== null && contactDetails !== void 0 ? contactDetails : defaultContactDetails;
    var email = contact.email, phone = contact.phone;
    return /*#__PURE__*/ jsxs(Flex, {
        alignItems: "center",
        flexWrap: "wrap",
        gap: "12px",
        children: [
            Boolean(phone) && /*#__PURE__*/ jsx(StepLink, {
                href: "tel:".concat(phone),
                children: /*#__PURE__*/ jsx("span", {
                    children: phone
                })
            }),
            /*#__PURE__*/ jsx(Divider, {}),
            Boolean(email) && /*#__PURE__*/ jsx(StepLink, {
                href: "mailto:".concat(email),
                children: /*#__PURE__*/ jsx("span", {
                    children: email
                })
            })
        ]
    });
};

export { ContactDetails };
